import styled from 'styled-components';

export const CategoryPageWrapper = styled.div`
  margin-top: 0.875rem;
`;
